import { useFeatureFlags } from '@viveaesthetics/elemy-shared-core'

import { InsurancesEnum } from '@/types/providers'

import { useParams } from './useParams'

export const useIsInsuranceIdEnabled = () => {
  const flags = useFeatureFlags()
  const urlParams = useParams<{
    insurance: InsurancesEnum
    insuranceId: string
  }>()

  const hasInsuranceNameInParams = !!urlParams.insurance
  const shouldSupportIsInsuranceIdBackwardCompatibility =
    hasInsuranceNameInParams

  const isInsuranceIdFeatureEnabled =
    !!flags['pedp-3730-booking-optimize-Insurance-verification'] &&
    !!flags['pedp-3858-booking-insurance-id'] &&
    !shouldSupportIsInsuranceIdBackwardCompatibility

  return isInsuranceIdFeatureEnabled
}
